import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AutoHeightDialog } from "../../components/CommonComponents/Dialog/Dialog";
import Select from "../../components/CommonComponents/Select/Select";
import { ErrorToast } from "../../components/toastMessage";
import {
  useApplicationFormSteps,
  useNameOfServiceField,
} from "../../hooks/applications.hooks";
import { useToggle } from "../../hooks/common";

export default function SelectServiceTypeDialog({
  onClose,
}: {
  onClose: () => unknown;
}) {
  const [confirm, toggleConfirm] = useToggle();
  const navigate = useNavigate();
  const [selectedServiceType, setSelectedServiceType] = useState<
    number | undefined
  >(undefined);
  const { data: nameOfService } = useNameOfServiceField();
  const { data, isError, isFetching } = useApplicationFormSteps(
    selectedServiceType ?? undefined
  );

  useEffect(() => {
    if (isFetching) return;
    else if (selectedServiceType && (isError || !data?.data?.length)) {
      ErrorToast("Service Unavailable!");
    }
  }, [isError, selectedServiceType, data, isFetching]);

  const serviceOptions = nameOfService?.options || [];

  return (
    <AutoHeightDialog
      onClose={onClose}
      open
      className="rounded-xl md:w-[620px] !top-1/2 !-translate-y-1/2 !bottom-auto"
    >
      <div className="p-8">
        {confirm ? (
          <>
            <h5 className="m-0 grow text-2xl font-bold text-center">
              Are you sure you want to create the application with the selected
              service type?
            </h5>
            <p className="text-center mt-4">
              Once the application has been created, you cannot modify the
              service type.
            </p>
          </>
        ) : (
          <>
            <h5 className="m-0 grow text-2xl font-bold">Name of Service</h5>

            <Select
              containerClass="mt-8"
              value={selectedServiceType}
              onChange={(e) => setSelectedServiceType(+e.target.value)}
            >
              <option selected disabled>
                Select Service
              </option>

              {/*{nameOfService?.options?.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name}
                </option>
              ))}*/}
              {serviceOptions
              .filter(service => service.active)
              .map((service) => (
                <option
                  key={service.id}
                  value={service.id}
                  // CHANGE 3: Added disabled attribute based on service.active
                  // disabled={!service.active}
                  // // CHANGE 4: Added CSS class for disabled styling
                  // className={!service.active ? "text-gray-400" : ""}
                  // CHANGE 5: Added inline style as fallback for better browser compatibility
                  style={!service.active ? { color: '#9CA3AF' } : {}}
                >
                  {service.name}
                </option>
              ))}
            </Select>
          </>
        )}
        <div className="flex justify-center gap-4 items-center mt-8 flex-wrap md:flex-nowrap">
          <button
            type="button"
            onClick={() => {
              if (!confirm) toggleConfirm();
              else {
                navigate("/add-new-application", {
                  state: { name_of_service: selectedServiceType },
                });
              }
            }}
            disabled={isError || !data?.data?.length}
            className="bg-primary px-2 md:px-6 min-w-32 py-2 rounded-full font-bold text-white  disabled:bg-gray-200"
          >
            Ok
          </button>

          <button
            type="button"
            onClick={onClose}
            className="bg-black px-2 md:px-6 min-w-32 py-2 rounded-full font-bold text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </AutoHeightDialog>
  );
}
